<ng-template #businessHourModal let-modal>
  <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Add Business Hours</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"
          title="Close Modal"></button>
  </div>
  <div class="modal-body">
      <h5 class="modal-info-text">Set the standard hours for this place</h5>

      <div class="add-hour-wrap">
        <ng-container *ngFor="let hour of hourList" >
          <app-day-business-hour-item   [hour]="hour"></app-day-business-hour-item>
        </ng-container>
      </div>
      <div class="btn-grps">
          <button class="btn btn-outline-primary" title="Cancel" (click)="modal.close('Close click');">Cancel</button>
          <button class="btn btn-primary" title="Add Hours" (click)="bussinessHourAdded();modal.close('Close click');">Add Hours</button>
      </div>
  </div>
</ng-template>
